import {call, put, takeLatest} from 'redux-saga/effects'
import {DCore} from '../config'


import {
    VERIFY_CERTIFICATE,
    verifyCertificateSuccessfull
} from '../actions'



function * verifyCertificate (paylaod){
    try{
       const response=  yield call(DCore.get, `/members/memberships/certificates/${paylaod.data}/verify`)
        yield put (verifyCertificateSuccessfull(response.data))

    }catch(e){
        console.log("some thing went wrong", e)
    }
}


export function * verifyCertificateSaga(){
    yield takeLatest(VERIFY_CERTIFICATE,verifyCertificate)
}